"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_property_decorator_1 = require("vue-property-decorator");
const utils_1 = require("@/utils");
const vuex_1 = require("vuex");
const loading_spinner_vue_1 = tslib_1.__importDefault(require("@/components/loading-spinner/loading-spinner.vue"));
const utils_2 = require("@/store/modules/vehicleSelector/utils");
const uuid_1 = require("uuid");
const toggle_vue_1 = tslib_1.__importDefault(require("@/components/toggle/toggle.vue"));
const logger_1 = require("@/utils/logger");
const TrackingManager_1 = require("@/utils/TrackingManager");
let CleopatraWrapper = class CleopatraWrapper extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.cleoInitialised = false;
    }
    mounted() {
        this.fcisWidget = this.$refs.fcisWidget;
        this.initCleopatra();
    }
    created() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            const { VUE_APP_CLEOPATRA_SCRIPT_NO_MODULE = '', VUE_APP_CLEOPATRA_SCRIPT_MODULE = '' } = process.env;
            const aemEnv = (((_a = window.aemNamespace) === null || _a === void 0 ? void 0 : _a.pageEnvironmentVariables) || {}).stage;
            yield (0, utils_1.appendScript)(VUE_APP_CLEOPATRA_SCRIPT_MODULE.replace('{prefix}', aemEnv !== 'PROD' ? 'test.' : ''), {
                type: 'module',
            });
            yield (0, utils_1.appendScript)(VUE_APP_CLEOPATRA_SCRIPT_NO_MODULE.replace('{prefix}', aemEnv !== 'PROD' ? 'test.' : ''), {
                nomodule: '',
            });
        });
    }
    handleLinks() {
        return tslib_1.__awaiter(this, arguments, void 0, function* (links = []) {
            const cleopatraButtons = links.filter((item) => item.classification === utils_1.BUTTON_TYPE.LIST);
            const otherButtons = links.filter((item) => item.classification !== utils_1.BUTTON_TYPE.LIST);
            // Initially, remove the buttons that are not of type LIST
            this.fcisWidget.setButtons(cleopatraButtons);
            // Set the new buttons to the store
            yield this.setButtons(otherButtons);
        });
    }
    onFcisQuote(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            this.cleoInitialised = true;
            TrackingManager_1.tracking.setCleoStatus('success');
            if (!Object.keys(event.detail.containers).length) {
                logger_1.logger.log(['No quote data from FCIS']);
            }
            const { containers, widgetTitle, links, messages, financingProduct } = event.detail;
            const outputContainer = containers.find((container) => container.id === utils_1.OCAPI_CONTAINER.OUTPUT) || {};
            this.setCustomerType(financingProduct.customerType);
            yield this.handleLinks(links);
            this.setTitle(widgetTitle);
            this.setErrorMessages(messages);
            this.setQuoteData(outputContainer.items);
            const regulatoryContainer = containers.find((container) => container.id === utils_1.OCAPI_CONTAINER.REGULATORY);
            const urlParam = regulatoryContainer === null || regulatoryContainer === void 0 ? void 0 : regulatoryContainer.items.find(({ id }) => id === 'bannerUrl');
            const textParam = regulatoryContainer === null || regulatoryContainer === void 0 ? void 0 : regulatoryContainer.items.find(({ id }) => id === 'bannerText');
            const graphicsParam = regulatoryContainer === null || regulatoryContainer === void 0 ? void 0 : regulatoryContainer.items.find(({ id }) => id === 'bannerGraphics');
            this.setLegalBannerImage((_a = graphicsParam === null || graphicsParam === void 0 ? void 0 : graphicsParam.value) !== null && _a !== void 0 ? _a : urlParam === null || urlParam === void 0 ? void 0 : urlParam.value);
            this.setLegalBannerText(textParam === null || textParam === void 0 ? void 0 : textParam.value);
            this.setContactFormItems({
                modelClass: this.currentVehicle.classId,
                bodyType: this.currentVehicle.bodytypeId,
                modelName: this.currentVehicle.name,
                fuelType: (0, utils_2.getMainFuelType)(this.currentVehicle.fuelTypes),
                transmissionType: this.currentVehicle.transmissionType,
                brand: this.currentVehicle.brand,
                baumuster: this.currentVehicle.baumuster,
                modelYear: this.currentVehicle.modelYear,
                origin: 'FINCALC',
            });
            this.setAppStatus(utils_1.APP_STATUS.OK);
        });
    }
    dispatchActions(financialCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            window.sessionStorage.setItem('swsp:FCIS_DATA', JSON.stringify({
                financialCode,
                baumuster: this.currentVehicle.baumuster,
            }));
        });
    }
    generateFinanceCode(buttonId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const financialCode = (0, uuid_1.v4)();
            if (buttonId === utils_1.OCAPI_BUTTON_TYPE.CAR_CONFIGURATOR) {
                this.dispatchActions(financialCode);
            }
            else {
                this.setContactFormItems({
                    financialCode,
                });
                this.$emit('financial-code-set');
            }
            yield this.fcisWidget.changeVehicle({
                financialCode,
            });
        });
    }
    onFcisError() {
        this.setAppStatus(utils_1.APP_STATUS.WARNING);
        TrackingManager_1.tracking.setCleoStatus('fail');
    }
    onFcisCustomerType(event) {
        this.setCustomerTypeInput(event.detail);
        this.shouldDisplayCustomerTypeToggle(true);
    }
    onFcisDisclaimers({ detail }) {
        this.setDisclaimers(detail || []);
    }
    /**
     * Watchers
     */
    onVehicleUpdate(payload) {
        if (!payload) {
            return;
        }
        if (this.cleoInitialised) {
            this.fcisWidget.parameters = Object.assign(Object.assign({}, this.fcisWidget.parameters), { vehicleId: this.currentVehicle.typeId, productCode: payload.ccsId });
        }
        else {
            this.initCleopatra();
        }
    }
    onCleoParameterChange() {
        this.shouldDisplayCustomerTypeToggle(false);
        this.setButtons([]);
        if (this.cleoInitialised) {
            this.cleoInitialised = false;
            // Force cleopatra props (ex. environment) to be set first
            this.$nextTick(() => {
                this.initCleopatra();
            });
        }
    }
    onCustomerTypeToggleValueChange() {
        this.fcisWidget.changeCustomerInput(this.customerTypeToggleValue);
    }
    initCleopatra() {
        this.fcisWidget.parameters = {
            caller: 'owdc',
            market: this.market,
            locale: this.locale,
            customConfig: this.customConfiguration,
            customer: {
                type: this.defaultCustomerType || null,
                productType: this.defaultFinancingProduct || null,
            },
            vehicleId: this.currentVehicleTypeId,
            productCode: this.currentVehicle.ccsId,
        };
    }
};
tslib_1.__decorate([
    (0, vue_property_decorator_1.Watch)('currentVehicle')
], CleopatraWrapper.prototype, "onVehicleUpdate", null);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Watch)('market'),
    (0, vue_property_decorator_1.Watch)('locale'),
    (0, vue_property_decorator_1.Watch)('environment'),
    (0, vue_property_decorator_1.Watch)('customConfiguration')
], CleopatraWrapper.prototype, "onCleoParameterChange", null);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Watch)('customerTypeToggleValue')
], CleopatraWrapper.prototype, "onCustomerTypeToggleValueChange", null);
CleopatraWrapper = tslib_1.__decorate([
    (0, vue_property_decorator_1.Component)({
        name: 'CleopatraWrapper',
        components: { LoadingSpinner: loading_spinner_vue_1.default, Toggle: toggle_vue_1.default },
        computed: Object.assign({}, (0, vuex_1.mapGetters)([
            'market',
            'locale',
            'environment',
            'appStatus',
            'errorMessages',
            'currentVehicleTypeId',
            'currentVehicle',
            'customConfiguration',
            'defaultFinancingProduct',
            'defaultCustomerType',
            'displayCustomerTypeToggle',
            'cleoCustomerTypeInput',
            'customerTypeToggleValue',
            'isInsuranceAccordeonOpen',
        ])),
        methods: Object.assign({}, (0, vuex_1.mapActions)([
            'setDisclaimers',
            'setQuoteData',
            'setAppStatus',
            'setButtons',
            'setTitle',
            'setErrorMessages',
            'setContactFormItems',
            'setLegalBannerImage',
            'setLegalBannerText',
            'setCustomerType',
            'setCustomerTypeInput',
            'shouldDisplayCustomerTypeToggle',
        ])),
        data() {
            return { APP_STATUS: utils_1.APP_STATUS };
        },
    })
], CleopatraWrapper);
exports.default = CleopatraWrapper;
